import { Button, IconSet } from '@postscript/components';
import * as Dialog from '@radix-ui/react-dialog';

import { useLocalStorage } from 'react-use';

import { OnboardingWorkflow } from 'components/ProgressiveOnboarding/OnboardingWorkflow';
import { ProgressSplashscreen } from 'components/ProgressiveOnboarding/ProgressSplashScreen';

import type { Guide } from 'providers/ProgressiveOnboarding/types';

import classes from 'components/ProgressiveOnboarding/ProgressPanel.module.css';

export const ProgressPanel = ({ guide }: { guide: Guide }) => {
  const [splashDismissed, setSplashDismissed] = useLocalStorage(
    `progressive_onboarding_${guide.key}_splash_dismissed`,
    false,
  );

  const dismissSplash = () => {
    setSplashDismissed(true);
  };

  return (
    <div className={classes.popper}>
      <div className={classes.closeButton}>
        <Dialog.Close asChild>
          <Button
            icon={IconSet.Minus}
            variant="plain"
            size="large"
            aria-label="Close"
          />
        </Dialog.Close>
      </div>

      {/* Content Placeholder */}
      {guide.splashScreen && !splashDismissed ? (
        <ProgressSplashscreen dismiss={dismissSplash} />
      ) : (
        <OnboardingWorkflow guide={guide} />
      )}
    </div>
  );
};
